<template>
  <TabsLayout>
    <ElTabPane name="materialAnalysisList" label="素材分析"></ElTabPane>
    <ElTabPane name="labelAnalysis" label="标签分析"></ElTabPane>
    <!-- <ElTabPane name="labelGroupAnalysisLifeCycle" label="内容标签组分析"></ElTabPane> -->
    <ElTabPane name="materialAnalysisLifeCycle" label="分日数据" v-if="routeName === 'materialAnalysisLifeCycle'"></ElTabPane>
    <ElTabPane name="materialAnalysisDetail" label="计划数据" v-if="routeName === 'materialAnalysisDetail'"></ElTabPane>
    <ElTabPane name="materialAnalysisComments" label="素材评论" v-if="routeName === 'materialAnalysisComments'"></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
export default {
  name: 'MediasDefault2',
  components: {
    TabsLayout
  },

  computed: {
    routePath() {
      return this.$route.path
    },
    routeName() {
      return this.$route.name
    }
  }
}
</script>
<style lang="scss" scoped></style>
